import React from 'react'
import './services.css'
import {BiCheck} from 'react-icons/bi'

const Services = () => {
  return (
    <section id='services'>
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className="container services__container">
        {/* <article className='service'>
          <div className="service__head">
            <h3>UI/UX Design</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
            </li>
          </ul>
        </article>
        END OF UI/UX */}

        <article className='service'>
          <div className="service__head">
            <h3>Web Development</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Do you want to create a full fledged website for your product, we can surely discuss on that.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>We together, can implement our ideas and let the world use them through the beautiful web-applications</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>I have good experience in creating applications using React framework as well as using Mulesoft.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit.</p>
            </li>
          </ul>
        </article>
        {/* END OF Web Development */}

        <article className='service'>
          <div className="service__head">
            <h3>DevOps</h3>
          </div>

          <ul className='service__list'>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>We are obviously required to deliver the product end to end.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>Why to find someone else when you can have me onboard.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>As a DevOps Engineer, I have a good experience in creating and delivering services end-to-end through CI/CD.</p>
            </li>
            <li>
              <BiCheck className='service__list-icon'/>
              <p>I have good knowledge in DevOps tools like Git, Docker, Kubernetes, Jenkins, AWS, so I can help you for sure!</p>
            </li>
          </ul>
        </article>
        {/* END OF Content Creation */}
      </div>
    </section>
  )
}

export default Services
